import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Url } from "../url";

const initialState = {
  extras: [],
  selectedExtras: [],
  loadingExtras: false,
  error: null,
  pagination: {
    pageNumber: 1,
    pageSize: 5,
    totalRecords: 0,
    totalPages: 0,
  },
};

export const fetchCruiseExtras = createAsyncThunk(
  "extras/fetchCruiseExtras",
  async ({ payload, chainCode, pageNumber = 1, pageSize = 5, language = 'en' }) => {
    const response = await fetch(
      `${Url}/Booking/${language}/Extras?chainCode=${chainCode}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        method: "POST",
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    if (!response.ok) {
      throw new Error("Failed to fetch extras");
    }
    return await response.json();
  }
);

const extrasSlice = createSlice({
  name: "extras",
  initialState,
  reducers: {
    selectExtra: (state, action) => {
      const selected = state.extras.extras?.find(
        (extra) => extra.cruiseExtraID === action.payload.cruiseExtraID
      );

      if (selected) {
        if (action.payload.checked) {
          // Add to selectedExtra array if not already present
          if (
            !state.selectedExtras.some(
              (extra) => extra.cruiseExtraID === selected.cruiseExtraID
            )
          ) {
            state.selectedExtras.push(selected);
          }
        } else {
          // Remove from selectedExtras array if present
          state.selectedExtras = state.selectedExtras.filter(
            (extra) => extra.cruiseExtraID !== selected.cruiseExtraID
          );
        }
      }
    },
    removeExtra: (state, action) => {
      // Remove the extra from selectedExtras array
      state.selectedExtras = state.selectedExtras.filter(
        (extra) => extra.cruiseExtraID !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCruiseExtras.pending, (state) => {
        state.loadingExtras = true;
      })
      .addCase(fetchCruiseExtras.fulfilled, (state, action) => {
        state.loadingExtras = false;
        state.error = false;
        const newData = action.payload;
        
        // Always replace extras with new page data
        state.extras = newData;
        
        // Update pagination if it exists
        if (newData.pagination) {
          state.pagination = newData.pagination;
        }
      })
      .addCase(fetchCruiseExtras.rejected, (state, action) => {
        state.loadingExtras = false;
        state.error = action.error.message;
      });
  },
});

export const { selectExtra, removeExtra } = extrasSlice.actions;
export default extrasSlice.reducer;
